import { __exports as O } from "../../../../../../../../../_virtual/inbox-composer.js";
import "./default.js";
import { __exports as e } from "../../../../../../../../../_virtual/default.js";
Object.defineProperty(O, "__esModule", {
  value: !0
});
O.INBOX_COMPOSER_CONFIG = void 0;
var _ = e, r = Object.assign({}, _.DEFAULT_CONFIG, {
  ALLOW_UNKNOWN_PROTOCOLS: !0
});
O.INBOX_COMPOSER_CONFIG = r;
export {
  O as default
};
